import { render } from "./appMain.vue?vue&type=template&id=464ae525&scoped=true&ts=true"
import script from "./appMain.vue?vue&type=script&lang=ts"
export * from "./appMain.vue?vue&type=script&lang=ts"

import "./appMain.vue?vue&type=style&index=0&id=464ae525&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464ae525"]])

export default __exports__